var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClessidra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 21.25V16.25L12 11.875M17.75 21.25H20M17.75 21.25L6.25 21.25M6.25 21.25L6.25 16.25L12 11.875M6.25 21.25H4M12 11.875L17.75 7.5M12 11.875L6.25 7.5M17.75 7.5L17.75 2.75M17.75 7.5L6.25 7.5M6.25 7.5L6.25 2.75M6.25 2.75L17.75 2.75M6.25 2.75L4 2.75M17.75 2.75L20 2.75",
    stroke: "#191E1B",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClessidra);
export default __webpack_public_path__ + "static/media/clessidra.6458c61234abe479f85b7092bd05fcb5.svg";
export { ForwardRef as ReactComponent };